import { Component, input, model, output } from '@angular/core';

/**
 * Native-Angular port of the AngularJS `ftSwitch` element directive
 * (account-v1/.../components/common/switch/switch.{js,html}). A toggle
 * switch: checkbox bound to `state` + a label, with an outer wrapper that
 * gains a `disabled` class when disabledControl is truthy.
 *
 * v1 bindings:
 *   disabled-control / state / on-change
 * Native equivalent:
 *   [disabledControl] / [(state)] / (change)
 *
 * The unique-id trick from v1 (input id + label for=id) is preserved so
 * the label still toggles the checkbox via click.
 */
let _switchSeq = 0;

@Component({
    selector: 'ft-switch',
    templateUrl: './switch.component.html',
    standalone: false
})
export class FtSwitchComponent {
    readonly disabledControl = input<any>(false);
    readonly state = model(false);
    /** v1's `on-change` callback — fires after the state update. */
    readonly change = output<void>();

    protected readonly uid = `ft-switch-${++_switchSeq}`;

    protected onToggle(ev: Event): void {
        const next = (ev.target as HTMLInputElement).checked;
        this.state.set(next);
        this.change.emit();
    }
}
